import { render } from "./WToastPosition.vue?vue&type=template&id=aef1e20c&ts=true"
import script from "./WToastPosition.vue?vue&type=script&lang=ts"
export * from "./WToastPosition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__